import ModuleWrapper from 'shared-lib/containers/Module';

const EmailTemplates = () => import(/* webpackChunkName: "email-templates" */ '@/views/emailTemplates/EmailTemplates');
const EmailTemplateDetails = () => import(/* webpackChunkName: "email-template-details" */ '@/views/emailTemplates/EmailTemplateDetails');
const EmailTemplateForm = () => import(/* webpackChunkName: "email-template-form" */ '@/views/emailTemplates/EmailTemplateForm');
const EmailTemplatesLayoutForm = () => import(/* webpackChunkName: "email-template-layout-form" */ '@/views/emailTemplates/EmailTemplatesLayoutForm');

const meta = (data = {}) => ({
    permissionsModuleName: 'email_templates',
    title: 'Email Templates',
    auth: true,
    ...data,
});

export default [{
    path: 'email-templates',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
    }),
    children: [
        {
            path: '',
            name: 'Email Templates',
            component: EmailTemplates,
            meta: meta({
                permission: 'list',
            }),
        },
        {
            path: ':id(\\d+)',
            name: 'Email Template Details',
            props: true,
            component: EmailTemplateDetails,
            meta: meta({
                permission: 'list',
            }),
        },
        {
            path: 'add',
            name: 'Add Email Template',
            props: true,
            component: EmailTemplateForm,
            meta: meta({
                permission: 'create',
            }),
        },
        {
            path: ':id(\\d+)/edit',
            name: 'Edit Email Template',
            props: true,
            component: EmailTemplateForm,
            meta: meta({
                permission: 'update',
            }),
        },
        {
            path: 'add-layout',
            name: 'AddEmailTemplatesLayout',
            props: true,
            component: EmailTemplatesLayoutForm,
            meta: meta({
                permission: 'create',
            }),
        },
        {
            path: ':id(\\d+)/edit-layout',
            name: 'EditEmailTemplatesLayout',
            props: true,
            component: EmailTemplatesLayoutForm,
            meta: meta({
                permission: 'update',
            }),
        },
    ],
}];
